<template>
  <div >
    <div class="editor" ref="editor" :style="styles" @blur="onEditorBlur()" @focus="onEditorFocus()" ></div>
  </div>
</template>
  <script>
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'Editor',
  props: {
    /* 编辑器的内容 */
    value: { type: String, default: '' },
    height: { type: Number, default: null },
    minHeight: { type: Number, default: null },
    readOnly: { type: Boolean, default: false },
    type: { type: String, default: 'url' },
    placeholderValue: { type: String, default: '' },
  },
  data() {
    return {
      Quill: null,
      currentValue: '',
      options: {
        theme: 'snow',
        bounds: document.body,
        debug: 'warn',
        modules: {
          // 工具栏配置
          toolbar: [
            ['bold', 'underline'], // 加粗  下划线
            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
            [{ color: [] }], // 字体颜色
            [{ font: [] }],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ header: 1 }, { header: 2 }],
            ['image'],
            // [{ direction: 'rtl' }],
            // [{ 'color': [] }, { 'background': [] }]
          ],
        },
        placeholder: !this.readOnly ? '请输入内容' : '',
        readOnly: this.readOnly,
      },
    }
  },
  computed: {
    styles() {
      let style = {}
      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`
      }
      if (this.height) {
        style.height = `${this.height}px`
      }
      return style
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val !== this.currentValue) {
          this.currentValue = val === null ? '' : val
          this.$nextTick(() => {
            if (this.Quill) {
              //this.Quill.pasteHTML(this.currentValue);
              this.Quill.root.innerHTML = this.currentValue
              // var delta = new Delta().insert(this.currentValue)
              // this.Quill.setContents(delta)
            }
          })
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
    // this.$nextTick(()=>{
    // this.Quill.root.addEventListener('blur',this.onEditorBlur)
    // this.Quill.root.addEventListener('focus',this.onEditorFocus)
    // })
  },
  beforeDestroy() {
    this.Quill = null
  },
  methods: {
    init() {
      const editor = this.$refs.editor
      this.Quill = new Quill(editor, this.options)
      this.Quill.on('text-change', (delta, oldDelta, source) => {
        const html = this.$refs.editor.children[0].innerHTML
        const text = this.Quill.getText()
        const quill = this.Quill
        this.currentValue = html
        this.$emit('input', html)
        this.$emit('on-change', { html, text, quill })
      })
      this.Quill.on('text-change', (delta, oldDelta, source) => {
        this.$emit('on-text-change', delta, oldDelta, source)
      })
      this.Quill.on('selection-change', (range, oldRange, source) => {
        this.$emit('on-selection-change', range, oldRange, source)
      })
      this.Quill.on('editor-change', (eventName, ...args) => {
        this.$emit('on-editor-change', eventName, ...args)
      })
      this.addPasteListener(this.Quill)
    },

    addPasteListener(quill) {
      const editor = quill.root
      editor.addEventListener('paste', (evt) => {
        if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
          evt.preventDefault()
          ;[].forEach.call(evt.clipboardData.files, (file) => {
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
              return
            }
            const formData = new FormData()
            formData.append('file', file)
            formData.append('businessName', 'WorkReport')
            this.$HTTP.post('/Basics/FileUpDownload/ImgUploadToCos', formData, null).then((res) => {
              let regex = /<p>\s*<img\s+src="data:image\/png;base64,[^"]*"\s*\/?>\s*<\/p>/gi
              if (res.code == 1) {
                //let aferHtml = quill.root.innerHTML.replace(regex, '');
                // let _html = "<p>";
                // _html += "<img src='";
                // _html += res.result + "' />"
                // _html += "</p>";
                // quill.root.innerHTML = aferHtml + _html;
                let _html = "<p><img src='" + res.result + "' /></p>"
                quill.root.innerHTML = quill.root.innerHTML.replace(regex, _html)
              } else quill.root.innerHTML = quill.root.innerHTML.replace(regex, '')
            })
          })
        }
        false
      })
    },
    onEditorBlur(){
    },
    onEditorFocus(){
    }
  },
}
</script>
  <style scoped>
.editor,
.ql-toolbar {
  white-space: pre-wrap !important;
  line-height: normal !important;
}
::v-deep .ql-toolbar.ql-snow {
  padding: 0 !important;
}
/* .quill-img {
    display: none;
  }
  
  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
  }
  
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }
  
  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
  } */

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: '等宽字体';
}
::v-deep .ql-toolbar.ql-snow {
  padding: 0;
}
</style>
  